import { useContext } from 'react';
import { ObjectContext } from '../context/ObjectContext';
export const useObjectId = () => useContext(ObjectContext).objectId;